var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "16px",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Desktop-Media-Story-1",
    transform: "translate(-507.000000, -501.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(301.000000, 493.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(85.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-email",
    transform: "translate(121.160150, 1.800000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9887218,0 L1.86090226,0 C0.833141447,0 0,0.805875 0,1.8 L0,12.6 C0,13.594125 0.833141447,14.4 1.86090226,14.4 L17.9887218,14.4 C19.0164826,14.4 19.8496241,13.594125 19.8496241,12.6 L19.8496241,1.8 C19.8496241,0.805875 19.0164826,0 17.9887218,0 Z M17.9887218,1.8 L17.9887218,3.3301875 C17.1194478,4.0149 15.7336184,5.0796 12.7709457,7.3235625 C12.1180404,7.820325 10.8247133,9.0137625 9.92481203,8.99985 C9.02506579,9.0139125 7.73131227,7.8201375 7.07867834,7.3235625 C4.11647086,5.0799375 2.73029253,4.0150125 1.86090226,3.3301875 L1.86090226,1.8 L17.9887218,1.8 Z M1.86090226,12.6 L1.86090226,5.639925 C2.74925047,6.3243375 4.00904253,7.28475 5.92922227,8.73915 C6.77659187,9.3843375 8.26054511,10.808625 9.92481203,10.7999625 C11.5808987,10.808625 13.0460491,9.405 13.9200529,8.73945 C15.8401938,7.2850875 17.1003348,6.3244125 17.9887218,5.639925 L17.9887218,12.6 L1.86090226,12.6 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.fe32ca4247df32a91545d57b2ca768bb.svg";
export { ForwardRef as ReactComponent };